<template>
	<div>
		<div class="container_full">
			<div class="container margin_60_35">
				<div class="row">
					<div class="col-lg-6">
						<div>
							<img src="@/assets/img/logo.png" />
						</div>
						<div class="p-3">
							<h2>Propuesta</h2>
							<!--<p class="">Regístrate para Dispensar Recetas Digitales y acceder a beneficios para vos y tus clientes.</p>-->
							<div class="box_feat_2">
								<h3>La Primera Plataforma de Receta Digital del País.</h3>
								<ul>
									<li> Alineada con las normas del Gobierno (MSP, AGESIC, SaludUy).</li>
									<li> Desarrollada de acuerdo los mayores estándares tecnológicos internacionales.</li>
									<li> 100% de la oferta de fármacos, asegurada por el DNMA (Diccionario Nacional de Medicamentos).</li>
									<li> Accesible para todas las Farmacias, mediante cualquier navegador.</li>
									<li> Médicos de todas las especialidades y distribuidos en todo el País.</li>
									<li> Mayor eficiencia operaAva.</li>
									<li> Control detallado del historial de Dispensaciones.</li>
									<li> DemocraAzación de la oferta de cara al usuario.</li>
									<li> Nuevo canal de ventas y captación de clientes.</li>
									<li> Mejora la propuesta de servicio y aumenta la saAsfacción del usuario.</li>
								</ul>
							</div>
						</div>
					</div>

					<div class="col-lg-5 ml-auto">
						<div class="box_form">
							<VueSlickCarousel ref="carousel" v-bind="settings">
								<div>
									<FormulateForm v-if="!loading" ref="form" v-model="form" @submit="$refs.carousel.next()">
										<FormulateInput label="Nombre" name="name" validation-name="Nombre" validation="required" />

										<FormulateInput label="Razón Social" name="businessName" validation-name="Razón Social" validation="required" />
										<FormulateInput label="Cadena" name="franchise" :options="franchises" type="selectSearch" option-value="id" option-text="name" placeholder="Seleccione un cadena" :disabled="loadingCountries" />
										<FormulateInput label="RUT" name="rut" validation-name="Rut" validation="required" />
										<FormulateInput label="Teléfono" type="phone" name="phone" validation-name="Teléfono" validation="optional|^phone" />

										<div class="section-title mt-4 mb-2">Dirección</div>
										<div class="row row-xs">
											<!-- <div class="col-12 col-md-6 mb-2">
												<FormulateInput
													label="País"
													validation-name="País"
													name="addressCountry"
													:options="countries"
													type="selectSearch"
													option-value="id"
													option-text="name"
													placeholder="Seleccione un país"
													validation="required"
													:disabled="loadingCountries"
												/>
												<div class="formulate-input-help " v-if="loadingCountries">Cargando paises...</div>
											</div> -->
											<div class="col-12 col-md-6 mb-2">
												<FormulateInput
													label="Departamento"
													validation-name="Departamento"
													v-model="selectedRegion"
													:options="regions"
													type="selectSearch"
													option-value="id"
													option-text="name"
													placeholder="Seleccione una region"
													validation="required"
													:disabled="loadingCountries"
												/>
												<div class="formulate-input-help " v-if="loadingCountries">Cargando regiones...</div>
											</div>
											
											<div class="col-12 col-md-6 mb-2">
												<FormulateInput
													label="Localidad"
													validation-name="Localidad"
													name="addressLocality"
													:options="localities"
													type="selectSearch"
													option-value="id"
													option-text="name"
													placeholder="Seleccione una localidad"
													validation="required"
													:disabled="loadingCountries"
												/>
												<div class="formulate-input-help " v-if="loadingCountries">Cargando localidades...</div>
											</div>
											
											<!-- <div class="col-12 col-md-6 mb-2">
												<FormulateInput label="Ciudad" name="addressCity" validation-name="Ciudad" validation="required" />
											</div> -->
										</div>

										<div class="row row-xs">
											<div class="col-12 col-md-8 mb-2">
												<FormulateInput label="Calle" name="addressStreet" validation-name="Calle" validation="required" />
											</div>
											<div class="col-12 col-md-4 mb-2">
												<FormulateInput label="Número" name="addressNumber" validation-name="Número" validation="required" />
											</div>
										</div>
										<FormulateInput label="Datos adicionales" name="addressComments"  placeholder="Ej: manzana, solar, número de local, etc..." />

										
											
											

										<div class="d-flex justify-content-between mt-4">
											<FormulateInput type="button" data-ghost @click="$router.go(-1)">Cancelar</FormulateInput>
											<FormulateInput type="button" disabled v-if="saving">Guardando <span class="loader"/></FormulateInput>
											<FormulateInput type="submit" label="Siguiente" v-else />
										</div>

										
									</FormulateForm>
								</div>
								<div>
									<FormulateForm v-if="!loading" ref="form" v-model="form" @submit="save">
										<div class="section-title mt-4 mb-2">Dirección técnica</div>

										<FormulateInput label="Nombre" name="managerName" validation-name="Nombre encargado" validation="required" />

										<FormulateInput label="Apellido" name="managerLastname" validation-name="Apellido encargado" validation="required" />

										<FormulateInput type="identification" label="Documento de identidad" name="managerDocument" validation-name="Documento de identidad" validation="optional|^documentID" />

										<FormulateInput label="CJPPU" name="managerCJP" validation-name="CJPPU" validation="required" />

										<div class="section-title mt-4 mb-2">Datos de acceso</div>

										<FormulateInput label="Email" type="email" name="email" validation-name="Email" validation="required" />
										<FormulateInput label="Confirmar email" type="email" name="email_confirm" validation-name="Confirmar email" validation="required|confirm" />

										<FormulateInput label="Contraseña" type="password" name="password" :showMeter="true" placeholder="Contraseña" validation-name="Contraseña" validation="required" />

										<FormulateInput name="password_confirm" type="password" label="Confirmar contraseña" placeholder="Confirmar contraseña" validation="required|confirm" validation-name="Confirmar contraseña" />

										<FormulateInput
											name="terms"
											type="checkbox"
											label="Aceptar términos y condiciones"
											validation="required"
											validation-name="Términos y condiciones"
										/>

										<div class="d-flex justify-content-between mt-4">
											<FormulateInput type="button" data-ghost @click="$refs.carousel.prev()">Volver</FormulateInput>
											<FormulateInput type="button" disabled v-if="saving">Guardando <span class="loader"/></FormulateInput>
											<FormulateInput type="submit" label="Registrarme" v-else />
										</div>

										<div class="text-center mt-4">	
											Al crear una cuenta, acepto los <a href="https://recetalia.com/terms" target="_blank">Términos y condiciones</a> y las <a href="https://recetalia.com/privacy" target="_blank">Políticas de privacidad</a> de Recetalia.
										</div>
									</FormulateForm>
								</div>
							</VueSlickCarousel>
						</div>
						<p class="text-center link_bright">
							¿Ya estas registrado? <router-link tag="a" to="/login"><strong>Ingresar!</strong></router-link>
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import gql from "graphql-tag"
import { onLogin } from "../../vue-apollo"
import { mapMutations } from "vuex"
import VueSlickCarousel from "vue-slick-carousel"

import Password from "vue-password-strength-meter"
export default {
	name: "Register",
	metaInfo: {
		title: "Registrarme"
	},
	components: {
		Password,
		VueSlickCarousel
	},
	data() {
		return {
			form: {
				name: null,
				businessName: null,
				rut: null,
				email: null,
				managerName: null,
				managerLastname: null,
				managerDocument: {type:null, number:null},
				managerCJP: null,
				phone: null,
				password: null,
				passwordConfirm: null,
				address: { country: null, city: null, street: null },
				franchise: null
			},
			showPassword: false,
			saving: false,
			loading: false,
			passwordStrength: 0,
			loadingCountries: true,
			countries: [],
			regions: [],
			selectedRegion: null,
			franchises: [],
			settings: {
				arrows: false,
				dots: false,
				draggable: false,
				swipe: false,
				infinite: false
			}
		}
	},
	computed:{
		localities(){
			if(this.selectedRegion){
				return this.regions.find(r=>r.id==this.selectedRegion).localities
			}
			return []
		}
	},
	async beforeMount() {
		this.logout()
		await this.fetchData()
	},
	methods: {
		...mapMutations(["authSuccess", "logout"]),
		passwordScore(score) {
			this.passwordStrength = score
		},
		// nextStep1() {
		// 	this.$refs.carousel.next()
		// },

		save() {
			if (!this.saving) {
				this.saving = true
				let dataInput = {
					name: this.form.name,
					businessName: this.form.businessName,
					rut: this.form.rut,
					managerName: this.form.managerName,
					managerLastname: this.form.managerLastname,
					managerDocument: this.form.managerDocument,
					managerCJP: this.form.managerCJP,
					phone: this.form.phone,
					email: this.form.email,
					password: this.form.password,
					// addressCountry: this.form.addressCountry,
					addressCountry: 226,
					addressLocality: this.form.addressLocality,
					addressCity: this.form.addressCity,
					addressStreet: this.form.addressStreet,
					addressNumber: this.form.addressNumber,
					addressComments: this.form.addressComments,
					franchise: this.form.franchise
				}

				this.$apollo
					.mutate({
						mutation: gql`
							mutation($data: PharmacyRegisterInput!) {
								pharmacyRegister(data: $data) {
									token
									pharmacy {
										id
										name
										businessName
										email
									}
								}
							}
						`,
						variables: {
							data: dataInput
						}
					})
					.then(({ data }) => {
						this.$toast.success("Registro satisfactorio")
						let access_token = data.pharmacyRegister.token
						let logged_pharmacy = data.pharmacyRegister.pharmacy
						onLogin(this.$apollo.provider.defaultClient, access_token, logged_pharmacy).then(() => {
							this.authSuccess({ token: access_token, loggedPharmacy: logged_pharmacy })
							this.loading = false
							this.$router.push("/")
						})
					})
					.catch(error => {
						this.parseGQLErrors(error)
						this.saving = false
					})
			}
		},

		fetchData() {
			this.loadingCountries = true
			return this.$apollo
				.query({
					query: gql`
						query {
							countries {
								id
								iso
								name
								nativeName
								flag
							}
							franchises {
								data {
									id
									name
								}
							}
							regions{
								id
								name
								localities{
									id name
								}
							}
						}
					`,
					fetchPolicy: "network-only"
				})
				.then(({ data }) => {
					this.countries = data.countries
					this.regions = data.regions
					this.franchises = data.franchises.data
					this.loadingCountries = false
				})
				.catch(err => {
					console.log(err)
				})
		}
	}
}
</script>

<style scoped>
.container_full {
	
	display: flex;
	align-items: center;
	justify-content: center;
	height: auto !important;
	padding-top: 5% !important;
	max-width: 95% !important;
}
#hero_register {
	color: #5a5d5c;
}
#hero_register h1 {
	color: #5a5d5c;
}
@media (max-width: 767px) {
	#hero_register h1 {
		/* For less than 767px */
		font-size: 32px;
		font-size: 2rem;
	}
}

#register {
	margin: 60px auto;
	color: #fff;
}

#register h1 {
	font-size: 28px;
	font-size: 1.75rem;
	text-align: center;
	margin: 0 0 30px 0;
	color: #fff;
}

#login {
	width: 400px;
	margin: 60px auto;
	color: #fff;
}

@media (max-width: 767px) {
	#login {
		/* For less than 767px */
		width: 100%;
		margin: 30px 0;
	}
}

#login h1 {
	font-size: 28px;
	font-size: 1.75rem;
	text-align: center;
	margin: 0 0 30px 0;
	color: #fff;
}

@media (max-width: 767px) {
	#login h1 {
		/* For less than 767px */
		font-size: 21px;
		font-size: 1.3125rem;
	}
}

.divider {
	text-align: center;
	height: 1px;
	margin: 30px 0;
	background-color: #e1e8ed;
}

.divider span {
	position: relative;
	top: -20px;
	background-color: #fff;
	display: inline-block;
	padding: 10px;
	font-style: italic;
}

#login-2 {
	width: 650px;
	margin: 60px auto;
	color: #fff;
}

#login-2 .box_form {
	padding: 30px 0 0 0;
}

.box_form .form-group {
	margin-bottom: 1rem;
}

@media (max-width: 767px) {
	#login-2 .box_form {
		/* For less than 767px */
		padding: 20px 20px 0 20px;
	}
}

#login-2 .forgot {
	display: inline-block;
	margin-top: 5px;
}

@media (max-width: 767px) {
	#login-2 {
		/* For less than 767px */
		width: 100%;
		margin: 0;
	}
}

#login-2 h1 {
	font-size: 28px;
	font-size: 1.75rem;
	text-align: center;
	margin: 0 0 30px 0;
	color: #fff;
}

.box_login {
	width: 50%;
	float: left;
	border-right: 1px solid #e1e8ed;
	padding: 15px 25px;
}

@media (max-width: 767px) {
	.box_login {
		/* For less than 767px */
		width: 100%;
		border-right: 0;
		padding: 0;
	}
}

.box_login.last {
	border-right: 0;
}

a.social_bt {
	-webkit-border-radius: 3px;
	-moz-border-radius: 3px;
	-ms-border-radius: 3px;
	border-radius: 3px;
	text-align: center;
	color: #fff;
	min-width: 200px;
	margin-bottom: 15px;
	display: block;
	padding: 12px;
	line-height: 1;
	position: relative;
	-moz-transition: all 0.3s ease-in-out;
	-o-transition: all 0.3s ease-in-out;
	-webkit-transition: all 0.3s ease-in-out;
	-ms-transition: all 0.3s ease-in-out;
	transition: all 0.3s ease-in-out;
	cursor: pointer;
}

a.social_bt:hover {
	-webkit-filter: brightness(115%);
	filter: brightness(115%);
}

a.social_bt.facebook:before,
a.social_bt.google:before,
a.social_bt.linkedin:before {
	font-family: "ElegantIcons";
	position: absolute;
	left: 12px;
	top: 10px;
	font-size: 1rem;
	color: #fff;
}

a.social_bt.facebook {
	background-color: #3b5998;
}

a.social_bt.facebook:before {
	content: "\e093";
}

a.social_bt.google {
	background-color: #dc4e41;
}

a.social_bt.google:before {
	content: "\e096";
	top: 12px;
}

a.social_bt.linkedin {
	background-color: #0077b5;
}

a.social_bt.linkedin:before {
	content: "\e09d";
}

.box_feat_2 {
	position: relative;
}
.box_feat_2 h3 {
	font-size: 18px;
	font-size: 1.125rem;
	color: #616161;
}
.box_feat_2 i {
	font-size: 46px;
	font-size: 2.875rem;
	margin-bottom: 10px;
	color: #74d1c6;
	position: absolute;
	left: 0;
	top: 0;
}

.btn_1 {
	display: table;
	margin: auto;
}

.link_bright a {
	color: #12bcec;
}
</style>
